import { render, staticRenderFns } from "./ModalInsercaoResultadosLaudo.vue?vue&type=template&id=72ac6dfa&lang=pug"
import script from "./ModalInsercaoResultadosLaudo.vue?vue&type=script&lang=js"
export * from "./ModalInsercaoResultadosLaudo.vue?vue&type=script&lang=js"
import style0 from "./ModalInsercaoResultadosLaudo.vue?vue&type=style&index=0&id=72ac6dfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports